import blackPoint from './black-point.svg';
import grayPoint from './gray-point.svg';
import warehouse from './warehouse.svg';

const images = { blackPoint, grayPoint, warehouse };

export default images;
